module.exports = __webpack_public_path__ + "img/handshake-trade.a340d2e5.jpg";